<google-map [options]="options" height="100%" width="100%" (mapInitialized)="mapIsReady($event)"
  (maptypeidChanged)="changeType()">
  @if (markers&&(closeMarker$|async)) {
    @for (marker of markers; track marker; let index = $index) {
      <map-marker
        [label]="marker.label??''"
        [icon]="marker.icon??''"
        #mapMarker="mapMarker"
        (mapClick)="openInfoWindow(mapMarker,marker)"
        [position]="marker.location"
        >
      </map-marker>
    }
    <map-info-window>
      @if (marker$|async; as marker) {
        <div>
          @if (marker.name) {
            <div style="color: #0b0f16;font-weight: bold">
              {{marker.name}}
            </div>
          }
          @if (marker.infoWindow!=null&&marker.infoWindow.buttons!=null) {
            @if (marker.infoWindow.buttons; as buttons) {
              @for (button of buttons; track button) {
                <button mat-icon-button [color]="button.color"
                  (click)="clickInfoWindowButton(button.action)">
                  @if (button.iconMaterial) {
                    <mat-icon>
                      {{button.iconMaterial}}
                    </mat-icon>
                  }
                </button>
              }
            }
          }
        </div>
      }
    </map-info-window>
  }
</google-map>
